import { Base } from "./base";

export class Permission extends Base {
  /**
   * @description List Sublocation API function
   * @param {object} filterParams
   * @param {?string} filterParams.location Location ID associated with the sublocation
   * @returns {Promise<Response>}
   */
  list() {
    const url = new URL(this._getFullURL("/cmms/permission"));
    return fetch(url, this._generateRequestBody({}));
  }


 
}
